import RequestBase from '../Resources/RequestBase';

export default class PostcodeSearchRequest extends RequestBase {
    constructor(success) {
        super();
        this._url = '/customers/{customerId}/CreditDecision';
        this.method = 'GET';
        this.test = true;
        this.success = success;
        this.error = {
            statusCode: 404,
            statusMessage: 'Not Found',
            body: 'No decision for this customer.'
        };
        this.data = {
            data: {
                status: 'Approved',
                amount: 1500.00,
                reason: ''
            }
        };
    }
}



// WEBPACK FOOTER //
// ./src/TestResources/Decisions.js